/* eslint-disable no-param-reassign */
function percentage(fraction) {
  if (!fraction) return null;

  if (fraction === '0/0') return 0;
  const numerator = fraction.split('/')[0];
  const denominator = fraction.split('/')[1];
  return Math.round((numerator / denominator) * 100);
}

function formatDate(isoDate) {
  if (!isoDate) return null;

  const date = new Date(isoDate);
  const now = new Date();
  const diffInDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));

  // Formats the time in HH:MM format
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const time = `${hours}:${minutes}`;

  if (diffInDays === 0) {
    return `Hoje às ${time}`;
  }

  if (diffInDays === 1) {
    return `Ontem às ${time}`;
  }

  // Formats the date in DD/MM/YYYY format
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year} às ${time}`;
}

function isValidDate(dateString) {
  const date = dateString.substring(0, 10);

  // First check for the pattern
  // eslint-disable-next-line
  if (!/^\d{4}\-\d{1,2}\-\d{1,2}$/.test(date)) {
    return false;
  }

  // Parse the date parts to integers
  const parts = date.split('-');
  const day = parseInt(parts[2], 10);
  const month = parseInt(parts[1], 10);
  const year = parseInt(parts[0], 10);

  // Check the ranges of month and year
  if (year < 1000 || year > 3000 || month === 0 || month > 12) {
    return false;
  }

  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Adjust for leap years
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
    monthLength[1] = 29;
  }

  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1];
}

function isEmpty(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

function isValidEmail(email) {
  const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regexEmail.test(email);
}

function isValidCPF(cpf) {
  cpf = cpf.replace(/[^\d]/g, '');

  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
    return false;
  }

  let soma = 0;
  let resto;

  for (let i = 1; i <= 9; i++) {
    soma += Number(cpf.substring(i - 1, i)) * (11 - i);
  }

  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== Number(cpf.substring(9, 10))) return false;

  soma = 0;

  for (let i = 1; i <= 10; i++) {
    soma += Number(cpf.substring(i - 1, i)) * (12 - i);
  }

  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== Number(cpf.substring(10, 11))) return false;

  return true;
}

function isValidCellphone(phoneNumber) {
  const phoneRegex = /^\(\d{2,3}\) \s?\d{4,5}-\d{4}$/; // Ex: (01) 23456-7891
  return phoneRegex.test(phoneNumber);
}

function calculateCheckDigit(cnpjBase, weights) {
  const sum = cnpjBase
    .split('')
    .reduce((acc, digit, index) => acc + parseInt(digit, 10) * weights[index], 0);
  const remainder = sum % 11;
  return remainder < 2 ? '0' : (11 - remainder).toString();
}

function isValidCNPJ(cnpj) {
  cnpj = cnpj.replace(/[^\d]/g, '');

  if (cnpj.length !== 14) return false;

  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const firstCheckDigit = calculateCheckDigit(cnpj.slice(0, 12), weights1);
  const secondCheckDigit = calculateCheckDigit(cnpj.slice(0, 12) + firstCheckDigit, weights2);

  return cnpj.endsWith(firstCheckDigit + secondCheckDigit);
}

function isValidZipCode(zipCode) {
  return /^[0-9]{5}-?[0-9]{3}$/.test(zipCode);
}

export {
  percentage,
  formatDate,
  isValidDate,
  isEmpty,
  isValidEmail,
  isValidCPF,
  isValidCellphone,
  isValidCNPJ,
  isValidZipCode,
};
